import { FC, HTMLAttributes, useState } from 'react';
import { SelectBox } from 'src/UI';
import API from './API';
import { IssuedDataType } from './Types';
import PlaceHolder from './PlaceHolder';
import { RenderOptionType, getHtmlHandler } from 'Src/UI/SelectBox';

interface IIssuePassportProps extends HTMLAttributes<HTMLDivElement> {
	/** Поисковая строка по умолчанию */
	defaultSearchTerm?: string;
	/** Плэйсхолдер */
	placeholder?: string;
	/** Лимит вариантов ( максимум 10 ) */
	searchLimit?: number;
	/** Разрешить очистку результата */
	allowClear?: boolean;
	/** Только для чтения */
	readonly?: boolean;
	/** Флаг ошибки в поле */
	isInvalidate?: boolean;
	/** Текущее значение */
	value?: IssuedDataType | null;
	/** Вызывается при выборе значения */
	onChangeIssue?: (issue: IssuedDataType | null) => void;
}

/** Компонента для выбора и отображения информации "Кем выдан паспорт" */
export const IssuePassport: FC<IIssuePassportProps> = (props) => {
	const {
		defaultSearchTerm = '',
		isInvalidate,
		searchLimit = 10,
		value,
		onChangeIssue,
		onBlur,
		...otherProps
	} = props;

	const [isWait, setIsWait] = useState<boolean>(false);
	const [options, setOptions] = useState<IssuedDataType[]>([]);
	const [isOpen, setIsOpen] = useState<boolean>(false);

	const onChangeValue = (issue: IssuedDataType | null) => {
		if (onChangeIssue) {
			onChangeIssue(issue);
		}
	};

	const onClearHandler = () => {
		onChangeValue(null);
		setIsOpen(true);
	};

	const onChangeSelectedHandler = (selected: any[]) => {
		if (selected.length) {
			onChangeValue(selected[0]);
		} else {
			onChangeValue(null);
		}
		setIsOpen(false);
	};

	const onSearch = (searchText = '') => {
		setOptions([]);
		if (!searchText) {
			return;
		}
		setIsWait(true);
		API.searchData(searchText, searchLimit)
			.then((res) => {
				if (res.hasError || !res.result) {
					setOptions([]);
					return;
				}
				setOptions(res.result);
				if (!isOpen) {
					setIsOpen(true);
				}
			})
			.finally(() => {
				return setIsWait(false);
			});
	};

	const renderOption: RenderOptionType = (
		item,
		isSelected,
		searchText,
		index,
		getHtml: getHtmlHandler,
	) => {
		const code = () => {
			return (
				<p
					dangerouslySetInnerHTML={{
						__html: getHtml(item.code, searchText),
					}}
				/>
			);
		};
		const name = () => {
			return (
				<span
					dangerouslySetInnerHTML={{
						__html: getHtml(item.name, searchText),
					}}
				/>
			);
		};
		const searchByCode = /^\d{3}-\d{3}$/.test(searchText);
		return (
			<div>
				{searchByCode ? code() : name()}
				{searchByCode ? name() : code()}
			</div>
		);
	};

	const renderContent = () => {
		if (!!value && !!value.code && !!value.name && !isOpen) {
			return (
				<PlaceHolder
					data={value}
					onClear={onClearHandler}
					onOpen={() => {
						return setIsOpen(true);
					}}
					onBlur={onBlur}
					{...otherProps}
				/>
			);
		} else {
			return (
				<SelectBox
					minSearchLength={1}
					isInvalidate={isInvalidate && !isOpen}
					selectedValues={[value]}
					defaultSearchTerm={value ? value.name : ''}
					options={options}
					isWait={isWait}
					defaultOpen={isOpen}
					valueField="code"
					titleField="name"
					onSearch={onSearch}
					onChangeSelected={onChangeSelectedHandler}
					onRenderOption={renderOption}
					onChangeOpen={(open) => {
						return !open && setIsOpen(false);
					}}
					{...otherProps}
				/>
			);
		}
	};

	return renderContent();
};
